<template>
    <div class="mx-auto max-w-[500px]">
        <login-modal @close="handleDone" />
    </div>
</template>

<script setup lang="ts">
import LoginModal from '~/components/Verification/LoginModal.vue'
import { useRouter } from 'vue-router'
import { useActiveFacility } from '~/composables/use-active-facility'
import { useRouteLink } from '~/composables/routing'
import { useHead } from 'unhead'
import { useRoute } from '#app'
import { useLayoutMode } from '~/composables/use-layout-mode'
import { useViewer } from '~/composables/use-login'

const activeFacility = useActiveFacility()
const router = useRouter()

useHead({
    title: () => activeFacility.value.title + ' | Sign In'
})

const { facilityHomeLink } = useRouteLink()
const { preserveModeLink } = useLayoutMode()
const route = useRoute()
function handleDone() {
    if (
        typeof route.query.redirect === 'string' &&
        route.query.redirect.length > 0
    ) {
        router.push(preserveModeLink(decodeURIComponent(route.query.redirect)))
    } else {
        router.replace(facilityHomeLink(activeFacility.value.slug))
    }
}

const viewer = useViewer()
if (viewer.value !== undefined) {
    if (
        typeof route.query.redirect === 'string' &&
        route.query.redirect !== ''
    ) {
        router.push(preserveModeLink(decodeURIComponent(route.query.redirect)))
    } else {
        router.push(facilityHomeLink(activeFacility.value.slug))
    }
}
</script>
